const HomeIcon = ({style}) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{...style}}>
      <path
        d="M3 10.5653C3 9.99094 3 9.70376 3.07403 9.4393C3.1396 9.20503 3.24737 8.98469 3.39203 8.7891C3.55534 8.5683 3.78202 8.39199 4.23539 8.03937L11.0177 2.76424C11.369 2.49099 11.5447 2.35436 11.7387 2.30184C11.9098 2.2555 12.0902 2.2555 12.2613 2.30184C12.4553 2.35436 12.631 2.49099 12.9823 2.76424L19.7646 8.03937C20.218 8.39199 20.4447 8.5683 20.608 8.7891C20.7526 8.98469 20.8604 9.20503 20.926 9.4393C21 9.70376 21 9.99094 21 10.5653V17.8002C21 18.9203 21 19.4804 20.782 19.9082C20.5903 20.2845 20.2843 20.5905 19.908 20.7822C19.4802 21.0002 18.9201 21.0002 17.8 21.0002H6.2C5.0799 21.0002 4.51984 21.0002 4.09202 20.7822C3.71569 20.5905 3.40973 20.2845 3.21799 19.9082C3 19.4804 3 18.9203 3 17.8002V10.5653Z"
        fill="#878787"
      />
      <path
        d="M8 17.0002H16M11.0177 2.76424L4.23539 8.03937C3.78202 8.39199 3.55534 8.5683 3.39203 8.7891C3.24737 8.98469 3.1396 9.20503 3.07403 9.4393C3 9.70376 3 9.99094 3 10.5653V17.8002C3 18.9203 3 19.4804 3.21799 19.9082C3.40973 20.2845 3.71569 20.5905 4.09202 20.7822C4.51984 21.0002 5.07989 21.0002 6.2 21.0002H17.8C18.9201 21.0002 19.4802 21.0002 19.908 20.7822C20.2843 20.5905 20.5903 20.2845 20.782 19.9082C21 19.4804 21 18.9203 21 17.8002V10.5653C21 9.99094 21 9.70376 20.926 9.4393C20.8604 9.20503 20.7526 8.98469 20.608 8.7891C20.4447 8.5683 20.218 8.39199 19.7646 8.03937L12.9823 2.76424C12.631 2.49099 12.4553 2.35436 12.2613 2.30184C12.0902 2.2555 11.9098 2.2555 11.7387 2.30184C11.5447 2.35436 11.369 2.49099 11.0177 2.76424Z"
        stroke="#0F0F0F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const DashboardIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z"
        fill="white"
        fillOpacity="0.87"
      />
      <path d="M8 15V17V15Z" fill="white" fillOpacity="0.87" />
      <path d="M12 11V17V11Z" fill="white" fillOpacity="0.87" />
      <path d="M16 7V17V7Z" fill="white" fillOpacity="0.87" />
      <path
        d="M8 15V17M12 11V17M16 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
        stroke="#2F2F2F"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const BubbleChartIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1441_9935)">
        <path
          d="M7.2 17.6002C8.96731 17.6002 10.4 16.1675 10.4 14.4002C10.4 12.6329 8.96731 11.2002 7.2 11.2002C5.43269 11.2002 4 12.6329 4 14.4002C4 16.1675 5.43269 17.6002 7.2 17.6002Z"
          fill="#878787"
        />
        <path
          d="M14.7998 20C15.9044 20 16.7998 19.1046 16.7998 18C16.7998 16.8954 15.9044 16 14.7998 16C13.6952 16 12.7998 16.8954 12.7998 18C12.7998 19.1046 13.6952 20 14.7998 20Z"
          fill="#878787"
        />
        <path
          d="M15.2004 13.6C17.8514 13.6 20.0004 11.451 20.0004 8.8C20.0004 6.14903 17.8514 4 15.2004 4C12.5494 4 10.4004 6.14903 10.4004 8.8C10.4004 11.451 12.5494 13.6 15.2004 13.6Z"
          fill="#878787"
        />
      </g>
      <defs>
        <clipPath id="clip0_1441_9935">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const LineChartIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1441_9948)">
        <path
          d="M2.78973 14.78L2.69973 14.69C2.30973 14.3 2.30973 13.67 2.69973 13.28L8.78973 7.18003C9.17973 6.79003 9.80973 6.79003 10.1997 7.18003L13.4897 10.47L19.8797 3.29003C20.2597 2.86003 20.9297 2.85003 21.3297 3.25003C21.6997 3.63003 21.7197 4.23003 21.3697 4.62003L14.1997 12.69C13.8197 13.12 13.1597 13.14 12.7497 12.73L9.49973 9.48003L4.19973 14.78C3.81973 15.17 3.17973 15.17 2.78973 14.78ZM4.19973 20.78L9.49973 15.48L12.7497 18.73C13.1597 19.14 13.8197 19.12 14.1997 18.69L21.3697 10.62C21.7197 10.23 21.6997 9.63003 21.3297 9.25003C20.9297 8.85003 20.2597 8.86003 19.8797 9.29003L13.4897 16.47L10.1997 13.18C9.80973 12.79 9.17973 12.79 8.78973 13.18L2.69973 19.28C2.30973 19.67 2.30973 20.3 2.69973 20.69L2.78973 20.78C3.17973 21.17 3.81973 21.17 4.19973 20.78Z"
          fill="#878787"
        />
      </g>
      <defs>
        <clipPath id="clip0_1441_9948">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const LocalPoliceIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1441_9958)">
        <path
          d="M14.5 12.59L15.13 15.32C15.23 15.75 14.76 16.09 14.38 15.86L12 14.42L9.61 15.86C9.23 16.09 8.76 15.75 8.86 15.32L9.5 12.6L7.4 10.79C7.06 10.5 7.24 9.95 7.68 9.91L10.46 9.67L11.54 7.11C11.71 6.7 12.29 6.7 12.46 7.11L13.54 9.66L16.32 9.9C16.76 9.94 16.94 10.49 16.6 10.78L14.5 12.59ZM4.19 4.47C3.47 4.79 3 5.51 3 6.3V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V6.3C21 5.51 20.53 4.79 19.81 4.47L12.81 1.36C12.29 1.13 11.7 1.13 11.19 1.36L4.19 4.47Z"
          fill="#878787"
        />
      </g>
      <defs>
        <clipPath id="clip0_1441_9958">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const PersonSearchIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1441_9970)">
        <path
          d="M10 12C12.2091 12 14 10.2091 14 8C14 5.79086 12.2091 4 10 4C7.79086 4 6 5.79086 6 8C6 10.2091 7.79086 12 10 12Z"
          fill="#878787"
        />
        <path
          d="M10.35 14.01C7.62 13.91 2 15.27 2 18V19C2 19.55 2.45 20 3 20H11.54C9.07 17.24 10.31 14.11 10.35 14.01Z"
          fill="#878787"
        />
        <path
          d="M19.4296 18.02C19.8996 17.22 20.1296 16.25 19.9096 15.2C19.5696 13.56 18.1896 12.25 16.5296 12.04C13.8996 11.7 11.6796 13.91 12.0296 16.54C12.2496 18.2 13.5496 19.58 15.1896 19.92C16.2396 20.14 17.2096 19.91 18.0096 19.44L19.8696 21.3C20.2596 21.69 20.8896 21.69 21.2796 21.3C21.6696 20.91 21.6696 20.28 21.2796 19.89L19.4296 18.02ZM15.9996 18C14.8996 18 13.9996 17.1 13.9996 16C13.9996 14.9 14.8996 14 15.9996 14C17.0996 14 17.9996 14.9 17.9996 16C17.9996 17.1 17.0996 18 15.9996 18Z"
          fill="#878787"
        />
      </g>
      <defs>
        <clipPath id="clip0_1441_9970">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const NewsIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1441_9987)">
        <path
          d="M6.18 20.0001C7.38398 20.0001 8.36 19.0241 8.36 17.8201C8.36 16.6162 7.38398 15.6401 6.18 15.6401C4.97602 15.6401 4 16.6162 4 17.8201C4 19.0241 4.97602 20.0001 6.18 20.0001Z"
          fill="#878787"
        />
        <path
          d="M5.59 10.2298C4.75 10.0898 4 10.7798 4 11.6298C4 12.3398 4.53 12.9098 5.23 13.0298C8.15 13.5398 10.45 15.8498 10.97 18.7698C11.09 19.4698 11.66 19.9998 12.37 19.9998C13.22 19.9998 13.91 19.2498 13.78 18.4098C13.1 14.2098 9.79 10.8998 5.59 10.2298ZM5.56 4.51984C4.73 4.42984 4 5.09984 4 5.92984C4 6.65984 4.55 7.25984 5.27 7.32984C11.28 7.92984 16.06 12.7098 16.66 18.7198C16.73 19.4498 17.33 19.9998 18.06 19.9998C18.9 19.9998 19.56 19.2698 19.48 18.4398C18.75 11.0998 12.91 5.24984 5.56 4.51984Z"
          fill="#878787"
        />
      </g>
      <defs>
        <clipPath id="clip0_1441_9987">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const SearchIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1441_9998)">
        <path
          d="M15.4996 14.0001H14.7096L14.4296 13.7301C15.6296 12.3301 16.2496 10.4201 15.9096 8.39014C15.4396 5.61014 13.1196 3.39014 10.3196 3.05014C6.08965 2.53014 2.52965 6.09014 3.04965 10.3201C3.38965 13.1201 5.60965 15.4401 8.38965 15.9101C10.4196 16.2501 12.3296 15.6301 13.7296 14.4301L13.9996 14.7101V15.5001L18.2496 19.7501C18.6596 20.1601 19.3296 20.1601 19.7396 19.7501C20.1496 19.3401 20.1496 18.6701 19.7396 18.2601L15.4996 14.0001ZM9.49965 14.0001C7.00965 14.0001 4.99965 11.9901 4.99965 9.50014C4.99965 7.01014 7.00965 5.00014 9.49965 5.00014C11.9896 5.00014 13.9996 7.01014 13.9996 9.50014C13.9996 11.9901 11.9896 14.0001 9.49965 14.0001Z"
          fill="#878787"
        />
      </g>
      <defs>
        <clipPath id="clip0_1441_9998">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const MoneyIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1441_10008)">
        <path
          d="M11.8 10.9C9.53 10.31 8.8 9.7 8.8 8.75C8.8 7.66 9.81 6.9 11.5 6.9C12.92 6.9 13.63 7.44 13.89 8.3C14.01 8.7 14.34 9 14.76 9H15.06C15.72 9 16.19 8.35 15.96 7.73C15.54 6.55 14.56 5.57 13 5.19V4.5C13 3.67 12.33 3 11.5 3C10.67 3 10 3.67 10 4.5V5.16C8.06 5.58 6.5 6.84 6.5 8.77C6.5 11.08 8.41 12.23 11.2 12.9C13.7 13.5 14.2 14.38 14.2 15.31C14.2 16 13.71 17.1 11.5 17.1C9.85 17.1 9 16.51 8.67 15.67C8.52 15.28 8.18 15 7.77 15H7.49C6.82 15 6.35 15.68 6.6 16.3C7.17 17.69 8.5 18.51 10 18.83V19.5C10 20.33 10.67 21 11.5 21C12.33 21 13 20.33 13 19.5V18.85C14.95 18.48 16.5 17.35 16.5 15.3C16.5 12.46 14.07 11.49 11.8 10.9Z"
          fill="#878787"
        />
      </g>
      <defs>
        <clipPath id="clip0_1441_10008">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const MapIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1441_10018)">
        <path
          d="M14.65 4.97999L9.65 3.22999C9.23 3.07999 8.77 3.07999 8.35 3.21999L4.36 4.55999C3.55 4.83999 3 5.59999 3 6.45999V18.31C3 19.72 4.41 20.68 5.72 20.17L8.65 19.03C8.87 18.94 9.12 18.94 9.34 19.02L14.34 20.77C14.76 20.92 15.22 20.92 15.64 20.78L19.63 19.44C20.44 19.17 20.99 18.4 20.99 17.54V5.68999C20.99 4.27999 19.58 3.31999 18.27 3.82999L15.34 4.96999C15.12 5.04999 14.88 5.05999 14.65 4.97999ZM15 18.89L9 16.78V5.10999L15 7.21999V18.89Z"
          fill="#878787"
        />
      </g>
      <defs>
        <clipPath id="clip0_1441_10018">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const StockIcon = () => {
  return (
    <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.87454 0C5.8338 0 5.79284 0.00911676 5.75581 0.0277018L0.392101 2.71764C0.30807 2.75995 0.255415 2.84351 0.255415 2.93448V3.42356C0.255415 3.55855 0.36984 3.6681 0.510829 3.6681H11.2382C11.3795 3.6681 11.4937 3.55855 11.4937 3.42356V2.93448C11.4937 2.84351 11.4413 2.75995 11.357 2.71764L5.99327 0.0277018C5.95623 0.00911676 5.91528 0 5.87454 0ZM5.87454 1.46724C6.2975 1.46724 6.64078 1.79566 6.64078 2.20086C6.64078 2.60606 6.2975 2.93448 5.87454 2.93448C5.45132 2.93448 5.10829 2.60606 5.10829 2.20086C5.10829 1.79566 5.45132 1.46724 5.87454 1.46724ZM1.53249 4.15718C1.3915 4.15718 1.27707 4.26673 1.27707 4.40172V7.82528H2.80956V4.40172C2.80956 4.26673 2.69514 4.15718 2.55415 4.15718H1.53249ZM4.08663 4.15718C3.94565 4.15718 3.83122 4.26673 3.83122 4.40172V7.82528H5.36371V4.40172C5.36371 4.26673 5.24928 4.15718 5.10829 4.15718H4.08663ZM6.64078 4.15718C6.49954 4.15718 6.38537 4.24492 6.38537 4.353V6.70813C6.54347 6.64113 6.71729 6.60258 6.90118 6.60258H7.91785V4.353C7.91785 4.24492 7.80368 4.15718 7.66244 4.15718H6.64078ZM9.19493 4.15718C9.05368 4.15718 8.93951 4.23053 8.93951 4.32052V6.60258H10.472V4.32052C10.472 4.23053 10.3578 4.15718 10.2166 4.15718H9.19493ZM6.8962 7.09596C6.49423 7.09596 6.13444 7.39326 6.13444 7.79232V10.3036C6.13444 10.6884 6.47065 11 6.87275 11H11.2617C11.6635 11 12.0004 10.6881 12 10.3027V7.79232C12 7.39342 11.6403 7.09596 11.2382 7.09596H6.8962ZM10.1288 8.06982H10.7998C10.8925 8.06982 10.9674 8.1355 10.9674 8.21645V8.65681C10.9674 8.73775 10.8925 8.80344 10.7998 8.80344H10.1288C10.0361 8.80344 9.96117 8.73775 9.96117 8.65681V8.21645C9.96117 8.1355 10.0361 8.06982 10.1288 8.06982ZM0.766244 8.31436C0.625255 8.31436 0.510829 8.42367 0.510829 8.5589V9.04798H0.255415C0.114426 9.04798 0 9.15729 0 9.29252V10.0261C0 10.1614 0.114426 10.2707 0.255415 10.2707H5.61912V8.31436H0.766244ZM7.40703 9.29252H7.66244C7.80368 9.29252 7.91785 9.40207 7.91785 9.53706C7.91785 9.67204 7.80368 9.7816 7.66244 9.7816H7.40703C7.26578 9.7816 7.15161 9.67204 7.15161 9.53706C7.15161 9.40207 7.26578 9.29252 7.40703 9.29252ZM8.42868 9.29252H8.6841C8.82534 9.29252 8.93951 9.40207 8.93951 9.53706C8.93951 9.67204 8.82534 9.7816 8.6841 9.7816H8.42868C8.28744 9.7816 8.17327 9.67204 8.17327 9.53706C8.17327 9.40207 8.28744 9.29252 8.42868 9.29252ZM9.45034 9.29252H9.70576C9.847 9.29252 9.96117 9.40207 9.96117 9.53706C9.96117 9.67204 9.847 9.7816 9.70576 9.7816H9.45034C9.3091 9.7816 9.19493 9.67204 9.19493 9.53706C9.19493 9.40207 9.3091 9.29252 9.45034 9.29252ZM10.472 9.29252H10.7274C10.8687 9.29252 10.9828 9.40207 10.9828 9.53706C10.9828 9.67204 10.8687 9.7816 10.7274 9.7816H10.472C10.3308 9.7816 10.2166 9.67204 10.2166 9.53706C10.2166 9.40207 10.3308 9.29252 10.472 9.29252Z"
        fill="white"
        fillOpacity="0.6"
      />
    </svg>
  );
};

const CryptoIcon = () => {
  return (
    <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 5.96653C11 6.37024 9.82462 6.93424 7.91098 6.93424C7.44376 6.93424 6.99718 6.89872 6.58073 6.83027C6.58761 6.79216 6.59535 6.7549 6.59535 6.71592V5.61392C7.01181 5.67803 7.45236 5.71182 7.91098 5.71182C9.10873 5.71182 10.3581 5.46838 11 5.00835V5.96653ZM6.1548 6.71592C6.1548 7.1179 4.98373 7.68016 3.07697 7.68016C1.17021 7.68016 0 7.11877 0 6.71592V5.76294C0.640175 6.22123 1.88353 6.46294 3.07697 6.46294C4.27042 6.46294 5.51377 6.22123 6.1548 5.76294V6.71592ZM0 7.42286C0.641036 7.88115 1.88439 8.12373 3.07697 8.12373C4.27042 8.12373 5.51377 7.88115 6.1548 7.42286V8.37584C6.1548 8.77869 4.98373 9.34008 3.07697 9.34008C1.17107 9.34008 0 8.77869 0 8.37584V7.42286ZM11 2.63456C11 3.03828 9.82462 3.60227 7.91098 3.60227C5.99734 3.60227 4.82196 3.03828 4.82196 2.63456V1.67638C5.46386 2.13641 6.71237 2.37985 7.91098 2.37985C9.10873 2.37985 10.3581 2.13641 11 1.67638V2.63456ZM7.91098 0C9.82462 0 11 0.563992 11 0.967709C11 1.37229 9.82462 1.93628 7.91098 1.93628C5.99734 1.93628 4.82196 1.37229 4.82196 0.967709C4.82196 0.563992 5.99648 0 7.91098 0ZM4.82196 3.3415C5.46386 3.80239 6.71237 4.04584 7.91098 4.04584C9.10873 4.04584 10.3581 3.80239 11 3.3415V4.30054C11 4.70426 9.82462 5.26825 7.91098 5.26825C7.45236 5.26825 6.99718 5.231 6.58159 5.16342C6.58761 5.1279 6.59535 5.09325 6.59535 5.056C6.59535 4.46168 5.82697 4.0467 4.82196 3.82752V3.3415ZM3.07697 4.09175C4.98373 4.09175 6.1548 4.65315 6.1548 5.056C6.1548 5.45798 4.98373 6.01937 3.07697 6.01937C1.17021 6.01937 0 5.45798 0 5.056C0 4.65315 1.17107 4.09175 3.07697 4.09175ZM3.07697 11C1.17107 11 0 10.4386 0 10.0358V9.08278C0.640175 9.54107 1.88353 9.78365 3.07697 9.78365C4.27042 9.78365 5.51377 9.54107 6.1548 9.08278V10.0358C6.1548 10.4386 4.98373 11 3.07697 11ZM7.91098 8.60022C7.44634 8.60022 6.99977 8.5647 6.57987 8.49626C6.58761 8.45641 6.59535 8.41742 6.59535 8.37584V7.28077C7.01009 7.34402 7.4515 7.37781 7.91098 7.37781C9.10873 7.37781 10.3581 7.13436 11 6.67433V7.63251C11 8.03623 9.82462 8.60022 7.91098 8.60022Z"
        fill="white"
        fillOpacity="0.6"
      />
    </svg>
  );
};

const TwitterIcon = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.2918 18.6251C13.8371 18.6251 17.9652 12.3724 17.9652 6.95167C17.9652 6.77589 17.9613 6.5962 17.9535 6.42042C18.7566 5.83967 19.4496 5.12033 20 4.2962C19.2521 4.62896 18.458 4.84627 17.6449 4.94074C18.5011 4.42755 19.1421 3.62135 19.4492 2.67159C18.6438 3.14892 17.763 3.48563 16.8445 3.6673C16.2257 3.00976 15.4075 2.57439 14.5164 2.4285C13.6253 2.28261 12.711 2.43433 11.9148 2.8602C11.1186 3.28607 10.4848 3.96238 10.1115 4.78455C9.73825 5.60672 9.64619 6.52897 9.84961 7.4087C8.21874 7.32686 6.62328 6.90321 5.16665 6.1652C3.71002 5.4272 2.42474 4.39132 1.39414 3.12472C0.870333 4.02782 0.710047 5.09649 0.945859 6.11353C1.18167 7.13057 1.79589 8.01966 2.66367 8.60011C2.01219 8.57943 1.37498 8.40402 0.804688 8.08839V8.13917C0.804104 9.08691 1.13175 10.0056 1.73192 10.7391C2.3321 11.4726 3.16777 11.9756 4.09687 12.1626C3.49338 12.3277 2.85999 12.3518 2.2457 12.2329C2.50788 13.048 3.01798 13.7609 3.70481 14.2721C4.39164 14.7833 5.22093 15.0673 6.07695 15.0845C4.62369 16.226 2.82848 16.8452 0.980469 16.8423C0.652739 16.8418 0.325333 16.8217 0 16.7821C1.87738 17.9866 4.06128 18.6263 6.2918 18.6251Z"
        fill="white"
        fillOpacity="0.38"
      />
    </svg>
  );
};

const TelegramIcon = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1194_125936)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 10.5C20 16.0228 15.5228 20.5 10 20.5C4.47715 20.5 0 16.0228 0 10.5C0 4.97715 4.47715 0.5 10 0.5C15.5228 0.5 20 4.97715 20 10.5ZM10.3584 7.88244C9.38571 8.287 7.44178 9.12433 4.52658 10.3944C4.05319 10.5827 3.80521 10.7668 3.78264 10.9469C3.74449 11.2512 4.12559 11.3711 4.64456 11.5343C4.71515 11.5565 4.7883 11.5795 4.86328 11.6038C5.37386 11.7698 6.06069 11.964 6.41774 11.9717C6.74162 11.9787 7.10311 11.8452 7.5022 11.5711C10.226 9.7325 11.632 8.80317 11.7203 8.78314C11.7825 8.76901 11.8688 8.75123 11.9273 8.8032C11.9858 8.85518 11.98 8.9536 11.9738 8.98C11.9361 9.14095 10.4401 10.5317 9.66594 11.2515C9.42459 11.4759 9.2534 11.635 9.2184 11.6714C9.14 11.7528 9.06011 11.8298 8.98332 11.9038C8.50897 12.3611 8.15326 12.704 9.00301 13.264C9.41137 13.5331 9.73814 13.7556 10.0641 13.9776C10.4201 14.2201 10.7752 14.4619 11.2347 14.7631C11.3517 14.8398 11.4635 14.9195 11.5724 14.9971C11.9867 15.2925 12.359 15.5578 12.8188 15.5155C13.086 15.4909 13.3621 15.2397 13.5022 14.4903C13.8335 12.7193 14.4847 8.88205 14.6352 7.30081C14.6484 7.16227 14.6318 6.98498 14.6185 6.90715C14.6051 6.82931 14.5773 6.71842 14.4761 6.63633C14.3563 6.53911 14.1714 6.51861 14.0886 6.52007C13.7125 6.5267 13.1355 6.72735 10.3584 7.88244Z"
          fill="white"
          fillOpacity="0.38"
        />
      </g>
      <defs>
        <clipPath id="clip0_1194_125936">
          <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

const FacebookIcon = () => {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1194_125933)">
        <path
          d="M20 10.5C20 4.97715 15.5229 0.5 10 0.5C4.47715 0.5 0 4.97715 0 10.5C0 15.4912 3.65684 19.6283 8.4375 20.3785V13.3906H5.89844V10.5H8.4375V8.29688C8.4375 5.79063 9.93047 4.40625 12.2146 4.40625C13.3084 4.40625 14.4531 4.60156 14.4531 4.60156V7.0625H13.1922C11.95 7.0625 11.5625 7.8334 11.5625 8.625V10.5H14.3359L13.8926 13.3906H11.5625V20.3785C16.3432 19.6283 20 15.4912 20 10.5Z"
          fill="white"
          fillOpacity="0.38"
        />
      </g>
      <defs>
        <clipPath id="clip0_1194_125933">
          <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
};

const CopyIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 8V5.2C8 4.0799 8 3.51984 8.21799 3.09202C8.40973 2.71569 8.71569 2.40973 9.09202 2.21799C9.51984 2 10.0799 2 11.2 2H18.8C19.9201 2 20.4802 2 20.908 2.21799C21.2843 2.40973 21.5903 2.71569 21.782 3.09202C22 3.51984 22 4.0799 22 5.2V12.8C22 13.9201 22 14.4802 21.782 14.908C21.5903 15.2843 21.2843 15.5903 20.908 15.782C20.4802 16 19.9201 16 18.8 16H16M5.2 22H12.8C13.9201 22 14.4802 22 14.908 21.782C15.2843 21.5903 15.5903 21.2843 15.782 20.908C16 20.4802 16 19.9201 16 18.8V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H5.2C4.0799 8 3.51984 8 3.09202 8.21799C2.71569 8.40973 2.40973 8.71569 2.21799 9.09202C2 9.51984 2 10.0799 2 11.2V18.8C2 19.9201 2 20.4802 2.21799 20.908C2.40973 21.2843 2.71569 21.5903 3.09202 21.782C3.51984 22 4.07989 22 5.2 22Z"
        stroke="white"
        strokeOpacity="0.6"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const PinterestIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1204_127928)">
        <path
          d="M12 0C5.37188 0 0 5.37188 0 12C0 17.0859 3.16406 21.4266 7.62656 23.175C7.52344 22.2234 7.425 20.7703 7.66875 19.7344C7.88906 18.7969 9.075 13.7719 9.075 13.7719C9.075 13.7719 8.71406 13.0547 8.71406 11.9906C8.71406 10.3219 9.67969 9.075 10.8844 9.075C11.9062 9.075 12.4031 9.84375 12.4031 10.7672C12.4031 11.7984 11.7469 13.3359 11.4094 14.7609C11.1281 15.9562 12.0094 16.9313 13.1859 16.9313C15.3187 16.9313 16.9594 14.6812 16.9594 11.4375C16.9594 8.56406 14.8969 6.55313 11.9484 6.55313C8.53594 6.55313 6.52969 9.1125 6.52969 11.7609C6.52969 12.7922 6.92812 13.8984 7.425 14.4984C7.52344 14.6156 7.5375 14.7234 7.50937 14.8406C7.42031 15.2203 7.21406 16.0359 7.17656 16.2C7.125 16.4203 7.00313 16.4672 6.77344 16.3594C5.27344 15.6609 4.33594 13.4719 4.33594 11.7094C4.33594 7.92188 7.0875 4.44844 12.2625 4.44844C16.425 4.44844 19.6594 7.41563 19.6594 11.3813C19.6594 15.5156 17.0531 18.8438 13.4344 18.8438C12.2203 18.8438 11.0766 18.2109 10.6828 17.4656C10.6828 17.4656 10.0828 19.7578 9.9375 20.3203C9.66562 21.3609 8.93437 22.6688 8.44687 23.4656C9.57187 23.8125 10.7625 24 12 24C18.6281 24 24 18.6281 24 12C24 5.37188 18.6281 0 12 0Z"
          fill="#A8A8A8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1204_127928">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const InstagramIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1204_127929)">
        <path
          d="M12 2.16094C15.2063 2.16094 15.5859 2.175 16.8469 2.23125C18.0188 2.28281 18.6516 2.47969 19.0734 2.64375C19.6313 2.85938 20.0344 3.12188 20.4516 3.53906C20.8734 3.96094 21.1313 4.35938 21.3469 4.91719C21.5109 5.33906 21.7078 5.97656 21.7594 7.14375C21.8156 8.40937 21.8297 8.78906 21.8297 11.9906C21.8297 15.1969 21.8156 15.5766 21.7594 16.8375C21.7078 18.0094 21.5109 18.6422 21.3469 19.0641C21.1313 19.6219 20.8687 20.025 20.4516 20.4422C20.0297 20.8641 19.6313 21.1219 19.0734 21.3375C18.6516 21.5016 18.0141 21.6984 16.8469 21.75C15.5813 21.8062 15.2016 21.8203 12 21.8203C8.79375 21.8203 8.41406 21.8062 7.15313 21.75C5.98125 21.6984 5.34844 21.5016 4.92656 21.3375C4.36875 21.1219 3.96563 20.8594 3.54844 20.4422C3.12656 20.0203 2.86875 19.6219 2.65313 19.0641C2.48906 18.6422 2.29219 18.0047 2.24063 16.8375C2.18438 15.5719 2.17031 15.1922 2.17031 11.9906C2.17031 8.78438 2.18438 8.40469 2.24063 7.14375C2.29219 5.97187 2.48906 5.33906 2.65313 4.91719C2.86875 4.35938 3.13125 3.95625 3.54844 3.53906C3.97031 3.11719 4.36875 2.85938 4.92656 2.64375C5.34844 2.47969 5.98594 2.28281 7.15313 2.23125C8.41406 2.175 8.79375 2.16094 12 2.16094ZM12 0C8.74219 0 8.33438 0.0140625 7.05469 0.0703125C5.77969 0.126563 4.90313 0.332812 4.14375 0.628125C3.35156 0.9375 2.68125 1.34531 2.01563 2.01562C1.34531 2.68125 0.9375 3.35156 0.628125 4.13906C0.332812 4.90313 0.126563 5.775 0.0703125 7.05C0.0140625 8.33437 0 8.74219 0 12C0 15.2578 0.0140625 15.6656 0.0703125 16.9453C0.126563 18.2203 0.332812 19.0969 0.628125 19.8563C0.9375 20.6484 1.34531 21.3188 2.01563 21.9844C2.68125 22.65 3.35156 23.0625 4.13906 23.3672C4.90313 23.6625 5.775 23.8687 7.05 23.925C8.32969 23.9812 8.7375 23.9953 11.9953 23.9953C15.2531 23.9953 15.6609 23.9812 16.9406 23.925C18.2156 23.8687 19.0922 23.6625 19.8516 23.3672C20.6391 23.0625 21.3094 22.65 21.975 21.9844C22.6406 21.3188 23.0531 20.6484 23.3578 19.8609C23.6531 19.0969 23.8594 18.225 23.9156 16.95C23.9719 15.6703 23.9859 15.2625 23.9859 12.0047C23.9859 8.74688 23.9719 8.33906 23.9156 7.05938C23.8594 5.78438 23.6531 4.90781 23.3578 4.14844C23.0625 3.35156 22.6547 2.68125 21.9844 2.01562C21.3188 1.35 20.6484 0.9375 19.8609 0.632812C19.0969 0.3375 18.225 0.13125 16.95 0.075C15.6656 0.0140625 15.2578 0 12 0Z"
          fill="#A8A8A8"
        />
        <path
          d="M12 5.83594C8.59688 5.83594 5.83594 8.59688 5.83594 12C5.83594 15.4031 8.59688 18.1641 12 18.1641C15.4031 18.1641 18.1641 15.4031 18.1641 12C18.1641 8.59688 15.4031 5.83594 12 5.83594ZM12 15.9984C9.79219 15.9984 8.00156 14.2078 8.00156 12C8.00156 9.79219 9.79219 8.00156 12 8.00156C14.2078 8.00156 15.9984 9.79219 15.9984 12C15.9984 14.2078 14.2078 15.9984 12 15.9984Z"
          fill="#A8A8A8"
        />
        <path
          d="M19.8469 5.59238C19.8469 6.38926 19.2 7.03145 18.4078 7.03145C17.6109 7.03145 16.9688 6.38457 16.9688 5.59238C16.9688 4.79551 17.6156 4.15332 18.4078 4.15332C19.2 4.15332 19.8469 4.8002 19.8469 5.59238Z"
          fill="#A8A8A8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1204_127929">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

const FileIcon = ({style}) => {
  return (
    <svg width="17" height="22" viewBox="0 0 17 22" fill="none" xmlns="http://www.w3.org/2000/svg" style={{...style}}>
      <path
        d="M10.5 1.26953V5.40007C10.5 5.96012 10.5 6.24015 10.609 6.45406C10.7049 6.64222 10.8578 6.7952 11.046 6.89108C11.2599 7.00007 11.5399 7.00007 12.1 7.00007H16.2305M5.5 14L8.5 17M8.5 17L11.5 14M8.5 17L8.5 11M10.5 1H5.3C3.61984 1 2.77976 1 2.13803 1.32698C1.57354 1.6146 1.1146 2.07354 0.82698 2.63803C0.5 3.27976 0.5 4.11984 0.5 5.8V16.2C0.5 17.8802 0.5 18.7202 0.82698 19.362C1.1146 19.9265 1.57354 20.3854 2.13803 20.673C2.77976 21 3.61984 21 5.3 21H11.7C13.3802 21 14.2202 21 14.862 20.673C15.4265 20.3854 15.8854 19.9265 16.173 19.362C16.5 18.7202 16.5 17.8802 16.5 16.2V7L10.5 1Z"
        stroke="white"
        strokeOpacity="0.87"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const DiscordIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.23973 8.39014C7.66973 8.39014 7.21973 8.89014 7.21973 9.50014C7.21973 10.1101 7.67973 10.6101 8.23973 10.6101C8.80973 10.6101 9.25973 10.1101 9.25973 9.50014C9.26973 8.89014 8.80973 8.39014 8.23973 8.39014ZM11.8897 8.39014C11.3197 8.39014 10.8697 8.89014 10.8697 9.50014C10.8697 10.1101 11.3297 10.6101 11.8897 10.6101C12.4597 10.6101 12.9097 10.1101 12.9097 9.50014C12.9097 8.89014 12.4597 8.39014 11.8897 8.39014Z"
        fill="white"
        fillOpacity="0.6"
      />
      <path
        d="M16.7498 0H3.3498C2.2198 0 1.2998 0.92 1.2998 2.06V15.58C1.2998 16.72 2.2198 17.64 3.3498 17.64H14.6898L14.1598 15.79L15.4398 16.98L16.6498 18.1L18.7998 20V2.06C18.7998 0.92 17.8798 0 16.7498 0ZM12.8898 13.06C12.8898 13.06 12.5298 12.63 12.2298 12.25C13.5398 11.88 14.0398 11.06 14.0398 11.06C13.6298 11.33 13.2398 11.52 12.8898 11.65C12.3898 11.86 11.9098 12 11.4398 12.08C10.4798 12.26 9.5998 12.21 8.8498 12.07C8.2798 11.96 7.7898 11.8 7.37981 11.64C7.14981 11.55 6.8998 11.44 6.6498 11.3C6.6198 11.28 6.5898 11.27 6.5598 11.25C6.5398 11.24 6.5298 11.23 6.5198 11.22C6.3398 11.12 6.2398 11.05 6.2398 11.05C6.2398 11.05 6.7198 11.85 7.9898 12.23C7.68981 12.61 7.3198 13.06 7.3198 13.06C5.1098 12.99 4.2698 11.54 4.2698 11.54C4.2698 8.32 5.7098 5.71 5.7098 5.71C7.1498 4.63 8.5198 4.66 8.5198 4.66L8.6198 4.78C6.8198 5.3 5.9898 6.09 5.9898 6.09C5.9898 6.09 6.20981 5.97 6.5798 5.8C7.64981 5.33 8.4998 5.2 8.8498 5.17C8.9098 5.16 8.9598 5.15 9.0198 5.15C9.6298 5.07 10.3198 5.05 11.0398 5.13C11.9898 5.24 13.0098 5.52 14.0498 6.09C14.0498 6.09 13.2598 5.34 11.5598 4.82L11.6998 4.66C11.6998 4.66 13.0698 4.63 14.5098 5.71C14.5098 5.71 15.9498 8.32 15.9498 11.54C15.9498 11.54 15.0998 12.99 12.8898 13.06Z"
        fill="white"
        fillOpacity="0.6"
      />
    </svg>
  );
};

const AccountIcon = () => {
  return (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 3C11.66 3 13 4.34 13 6C13 7.66 11.66 9 10 9C8.34 9 7 7.66 7 6C7 4.34 8.34 3 10 3ZM10 17.2C7.5 17.2 5.29 15.92 4 13.98C4.03 11.99 8 10.9 10 10.9C11.99 10.9 15.97 11.99 16 13.98C14.71 15.92 12.5 17.2 10 17.2Z" fill="white" fill-opacity="0.38"/>
</svg>

  );
};

const GotoIcon= () => {
  return (
<svg width="8" height="12" viewBox="0 0 8 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M1.5 11L6.5 6L1.5 1" stroke="white" stroke-opacity="0.6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
  );
};

const SecurityPrivacyIcon = () => {
  return (
<svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 4L9 0L0 4V10C0 15.55 3.84 20.74 9 22C11.3 21.44 13.33 20.1 14.88 18.29L11.76 15.17C9.82 16.46 7.18 16.24 5.47 14.53C3.52 12.58 3.52 9.41 5.47 7.46C7.42 5.51 10.59 5.51 12.54 7.46C14.25 9.17 14.46 11.81 13.18 13.75L16.08 16.65C17.29 14.69 18 12.38 18 10V4Z" fill="white" fill-opacity="0.38"/>
</svg>

  );
};
const ProfileIcon = () => {
  return (
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM13.5 9C14.33 9 15 8.33 15 7.5C15 6.67 14.33 6 13.5 6C12.67 6 12 6.67 12 7.5C12 8.33 12.67 9 13.5 9ZM6.5 9C7.33 9 8 8.33 8 7.5C8 6.67 7.33 6 6.5 6C5.67 6 5 6.67 5 7.5C5 8.33 5.67 9 6.5 9ZM10 15.5C12.33 15.5 14.31 14.04 15.11 12H4.89C5.69 14.04 7.67 15.5 10 15.5Z" fill="white" fill-opacity="0.38"/>
</svg>

  );
};


const PayoutsIcon= () => {
  return (
<svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 10V2C18 0.9 17.1 0 16 0H2C0.9 0 0 0.9 0 2V10C0 11.1 0.9 12 2 12H16C17.1 12 18 11.1 18 10ZM9 9C7.34 9 6 7.66 6 6C6 4.34 7.34 3 9 3C10.66 3 12 4.34 12 6C12 7.66 10.66 9 9 9ZM22 3V14C22 15.1 21.1 16 20 16H3V14H20V3H22Z" fill="white" fill-opacity="0.38"/>
</svg>
  );
};


const ReferralLinksIcon = () => {
  return (
<svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 4C12 1.79 10.21 0 8 0C5.79 0 4 1.79 4 4C4 6.21 5.79 8 8 8C10.21 8 12 6.21 12 4ZM14 6V8H17V11H19V8H22V6H19V3H17V6H14ZM0 14V16H16V14C16 11.34 10.67 10 8 10C5.33 10 0 11.34 0 14Z" fill="white" fill-opacity="0.38"/>
</svg>

  );
};


const NotificationsIcon = () => {
  return (
<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 0H2C0.9 0 0.00999999 0.9 0.00999999 2L0 14C0 15.1 0.9 16 2 16H18C19.1 16 20 15.1 20 14V2C20 0.9 19.1 0 18 0ZM18 4L10 9L2 4V2L10 7L18 2V4Z" fill="white" fill-opacity="0.38"/>
</svg>

  );
};


const SubscriptionsIcon = () => {
  return (
<svg width="16" height="21" viewBox="0 0 16 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M15.48 11.3501C13.91 7.27014 8.32 7.05014 9.67 1.12014C9.77 0.68014 9.3 0.34014 8.92 0.57014C5.29 2.71014 2.68 7.00014 4.87 12.6201C5.05 13.0801 4.51 13.5101 4.12 13.2101C2.31 11.8401 2.12 9.87014 2.28 8.46014C2.34 7.94014 1.66 7.69014 1.37 8.12014C0.69 9.16014 0 10.8401 0 13.3701C0.38 18.9701 5.11 20.6901 6.81 20.9101C9.24 21.2201 11.87 20.7701 13.76 19.0401C15.84 17.1101 16.6 14.0301 15.48 11.3501ZM6.2 16.3801C7.64 16.0301 8.38 14.9901 8.58 14.0701C8.91 12.6401 7.62 11.2401 8.49 8.98014C8.82 10.8501 11.76 12.0201 11.76 14.0601C11.84 16.5901 9.1 18.7601 6.2 16.3801Z" fill="white" fill-opacity="0.38"/>
</svg>

  );
};


const BillingIcon= () => {
  return (
<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 0H2C0.89 0 0.00999999 0.89 0.00999999 2L0 14C0 15.11 0.89 16 2 16H18C19.11 16 20 15.11 20 14V2C20 0.89 19.11 0 18 0ZM18 14H2V8H18V14ZM18 4H2V2H18V4Z" fill="white" fill-opacity="0.38"/>
</svg>

  );
};

export {
  ReferralLinksIcon,
  NotificationsIcon,
  SubscriptionsIcon,
  BillingIcon,
  PayoutsIcon,
  SecurityPrivacyIcon,
  ProfileIcon,
  GotoIcon,
  AccountIcon,
  HomeIcon,
  DashboardIcon,
  BubbleChartIcon,
  LineChartIcon,
  LocalPoliceIcon,
  PersonSearchIcon,
  NewsIcon,
  SearchIcon,
  MoneyIcon,
  MapIcon,
  StockIcon,
  CryptoIcon,
  TwitterIcon,
  TelegramIcon,
  FacebookIcon,
  CopyIcon,
  PinterestIcon,
  InstagramIcon,
  FileIcon,
  DiscordIcon,
};
